import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const defaultUrls = {
  kgh: "https://kgh.ivote.mk/",
  corridor10: "https://corridor10.com/",
};

const ExternalUrlsContext = createContext(defaultUrls);

export const ExternalUrlsProvider = ({ children }) => {
  const [urls, setUrls] = useState(defaultUrls);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/api/Public/external-urls")
      .then((res) => {
        if (cancelled || !res.data) return;
        setUrls({
          kgh: res.data.kgh || defaultUrls.kgh,
          corridor10: res.data.corridor10 || defaultUrls.corridor10,
        });
      })
      .catch(() => {
        /* keep defaults */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => urls, [urls]);

  return (
    <ExternalUrlsContext.Provider value={value}>
      {children}
    </ExternalUrlsContext.Provider>
  );
};

export const useExternalUrls = () => useContext(ExternalUrlsContext);
